__turbopack_context__.v({
  "bazaarvoice-review-unavailable": "bazaarvoice-review-unavailable-component-module-scss-module__VwvFxq__bazaarvoice-review-unavailable",
  "bazaarvoice-review-unavailable__message": "bazaarvoice-review-unavailable-component-module-scss-module__VwvFxq__bazaarvoice-review-unavailable__message",
});
